module.exports = __webpack_public_path__ + "img/yanghu.0cabc2d9.svg";